import styled from "styled-components";

export const Items = styled.ul`
  list-style: none;
`;

export const Item = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${({ isFirst }) => isFirst ? '20px' : '10px'};
  padding-top: ${({ isFirst }) => isFirst ? '' : '5px'};
  border-top: ${({ isFirst }) => isFirst ? '' : '1px solid black'};

  div > {
    display: block;
  }

  div p {
    margin: 0;
  }

`;
